import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MenuItem} from '../../layout.component';
import {RouteService} from '../../../services/route/route.service';
import {Router} from '@angular/router';

export interface NavMenuData {
  menuItems: MenuItem[];
  currentUrl: string;
}

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent {
  public menuItems: MenuItem[];
  public helpItem: MenuItem;
  public currentUrl: string;
  private expandedCategories: string[] = [];

  constructor(public dialogRef: MatDialogRef<NavMenuComponent>,
              public routeService: RouteService,
              private router: Router,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: NavMenuData) {
    this.menuItems = data.menuItems;
    this.currentUrl = data.currentUrl;
    this.menuItems.forEach(item => {
      if (item.route === 'help') {
        this.helpItem = item;
      }
      (item.categories.concat(item?.primaryCategories || [])).forEach(menuCategory => {
        this.expandedCategories.push(menuCategory.label);
      });
    })
  }

  get currentRoute(): string {
    return this.currentUrl?.split('/')[2];
  }

  public toggleCategory(categoryLabel: string): void {
    if (this.expandedCategories.includes(categoryLabel)) {
      this.expandedCategories.splice(this.expandedCategories.indexOf(categoryLabel), 1);
    } else {
      this.expandedCategories.push(categoryLabel);
    }
  }

  public isExpanded(categoryLabel: string): boolean {
    return this.expandedCategories.includes(categoryLabel);
  }

  public chooseRoute(routerLink: string): void {
    this.dialogRef.close(routerLink);
  }

  isActive(route: string, menuItem?: MenuItem): boolean {
    const menuPath = '/app/' + this.currentRoute + route;
    if (this.router.url.split('/').length > menuPath.split('/').length) {
      if (!route.length) {
        let isActive = (menuItem.route === this.currentRoute);
        if (isActive) {
          menuItem?.items.forEach(item => {
            if (item.route.length) {
              if (this.router.url.includes(menuPath + item.route)) {
                isActive = false;
              }
            }
          });
        }
        return isActive;
      } else {
        return this.router.url.includes(menuPath);
      }
    }
    return this.router.url === menuPath;
  }

}
